import {
  UPDATE_START_ROUTE,
  UPDATE_END_ROUTE,
  CLEAR_ROUTE,
  CHANGE_ZOOM,
  CHANGE_CENTER,
  PREV_MAP,
  NEXT_MAP,
} from '../constants';

export function setStartPoint(point) {
  return dispatch => {
    dispatch({ type: UPDATE_START_ROUTE, payload: { x: point.lng, y: point.lat } });
  };
}

export function setEndPoint(point) {
  return dispatch => {
    dispatch({ type: UPDATE_END_ROUTE, payload: { x: point.lng, y: point.lat } });
  };
}

export function clearRoute() {
  return dispatch => {
    dispatch({ type: CLEAR_ROUTE });
  };
}
export function changeZoom(newZoomLevel) {
  return dispatch => {
    dispatch({ type: CHANGE_ZOOM, zoom: newZoomLevel });
  };
}
export function changeCenter(newCenter) {
  return dispatch => {
    dispatch({ type: CHANGE_CENTER, currentCenter: newCenter });
  };
}
export function setPrevMap() {
  return dispatch => {
    dispatch({ type: PREV_MAP });
  };
}
export function setNextMap() {
  return dispatch => {
    dispatch({ type: NEXT_MAP });
  };
}


// WEBPACK FOOTER //
// src/actions/routing.js